export const calculateTimeLeftLabel = ({
  text = '',
  endsIn,
  onTimerDoneHandler,
}: {
  text?: string;
  endsIn: number;
  onTimerDoneHandler?: () => void;
}): string | undefined => {
  const now = new Date().getTime();
  const difference = endsIn - now;

  let days = 0,
    hours = 0,
    minutes = 0;

  if (difference < -999) return;
  if (difference <= 0) {
    onTimerDoneHandler?.();
    return;
  }

  days = Math.floor(difference / (1000 * 60 * 60 * 24));
  hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
  minutes = Math.floor((difference / (1000 * 60)) % 60);

  if (days > 1) return `${text}${days}d ${hours}h`;
  if (days === 1 && hours > 0) return `1d ${hours}h`;
  if (days === 1 && hours === 0) return `${text}0d 24h`;
  if (hours === 1 && minutes === 0) return `${text}0h 60m`;
  if (hours >= 1) return `${text}${hours}h ${minutes}m`;
  if (minutes >= 1) return `${text}0h ${minutes}m`;

  return;
};
